import { ResourceType } from '@repo/api-gw-sdk';

export const AwsByovSupportedResourceTypes: ResourceType[] = [
  ResourceType.AwsEc2,
  ResourceType.AwsEksNamespace,
  ResourceType.AwsS3,
];
